import { InputMask } from '@react-input/mask';

import { ReducersTypes } from "../redux/reducers/Models";
import { Link } from 'react-router-dom';
import Icon from '@/atomic/atoms/Icon';
import Loading from '@/atomic/atoms/Loading';

export interface PropsView {
    toggleMenu: () => void;
    isVisibleMenu: boolean;
    user: ReducersTypes['userReducer'];
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    goToDebts: () => void;
    isDisabled: boolean;
    isLoading: boolean;
    error: boolean;
    isVisibleModal: boolean;
    toggleModal: () => void;
    goToCreateAccount: () => void;
    isAcceptedTerms: boolean;
    toggleTerms: () => void;
}

export default function IndexView({
  toggleMenu,
  isVisibleMenu,
  user,
  onChange,
  goToDebts,
  isDisabled,
  isLoading,
  error,
  isVisibleModal,
  toggleModal,
  isAcceptedTerms,
  toggleTerms,
}: PropsView) {
  const renderModal = () => (
    <div className="fixed flex flex-1 top-0 left-0 right-0 bottom-0 z-20 w-full bg-black/30 justify-center items-start text-black h-full min-h-screen">
      <div className="relative w-full max-w-[calc(480px)] max-h-full mt-[calc(100px)]">
        <div className="relative bg-white rounded-2xl shadow p-5">
         <div className="w-full flex flex-col items-center pb-3">
            <p className="self-center text-lg mt-3 font-bold mb-3">Atenção!</p>
            <div className="w-full h-px bg-slate-300 mt-2 mb-2" />
            <p className="text-sm mt-2 text-center">{error ? "Não foi possível buscar seus débitos. Tente novamente." : "Esse veículo já possui um meio de pagamento automático cadastrado, sua cobrança é automática e não é preciso buscar débitos no Pague Free Flow."}</p>
            <button type="button" onClick={toggleModal} className="mt-3 mb-3 bg-black border p-2 rounded-lg h-[calc(60px)] text-white w-full">Fechar</button>
          </div>
        </div>
      </div>
    </div>
  );
  return (
    <div className="w-full h-full bg-[url('./assets/home-mobile-3x.png')] md:bg-[url('./assets/home-desk-2x.png')] bg-cover bg-fixed bg-center">
      <div className="absolute inset-0 bg-black bg-opacity-50 backdrop-grayscale-0"></div>
      <main className="relative h-full w-full min-h-screen flex flex-col justify-between">
        <header className="flex flex-1 p-3 flex-wrap items-start">
          <nav className={`flex-col md:flex-row flex items-center w-full`}>
            <div className="flex justify-between items-center w-full md:w-auto">
              <Link to="/">
                <Icon 
                  className='dark md:hidden'
                />
              </Link>
              <button onClick={toggleMenu} data-collapse-toggle="navbar-default" type="button" className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-white border rounded-lg md:hidden focus:outline-none focus:ring-2 dark:text-gray-400" aria-controls="navbar-default" aria-expanded="false">
                <span className="sr-only">{isVisibleMenu ? "Close main menu" : "Open main menu"}</span>
                <img
                  src={isVisibleMenu ? "./icon-menu-close.png" : "./icon-menu.png"}
                  alt="ícone menu"
                  width={24}
                  height={24}
                />
              </button>
            </div>
            <ul id="navbar-default" className={`${!isVisibleMenu ? "hidden" : "text-center"} mt-2 md:mt-0 rounded-lg bg-white p-2 md:p-0 text-black md:bg-transparent md:text-white md:flex w-full justify-between items-center md:p-0 flex-col md:flex-row md:justify-around`}>
              <li className="p-2 pt-0 md:w-1/2">
                <Link to="/">
                  <Icon 
                    className='dark hidden md:block'
                  />
                </Link>
              </li>
              <div className="flex items-center flex-col md:flex-row w-full md:w-auto md:w-1/2">
                <li className="p-2">
                  <Link to="/ticket/user">
                    Meus recibos
                  </Link>
                </li>
                <li className="p-2">
                  <Link to="/faq">
                    Perguntas frequentes
                  </Link>
                </li>
              </div>
            </ul>
          </nav>
        </header>

        <article className="mt-5 md:h-[calc(100%-145px)] flex-1 flex p-3 justify-center items-center md:justify-around">
          <div className="hidden md:flex w-1/2 justify-center flex-col p-3">
            <h1 className="text-[4rem] font-bold leading-normal">APROVEITE TODAS AS VANTAGENS DO PAGUE <span className="text-principal">FREE</span> FLOW</h1>
            <h2 className="text-lg">Uma nova tecnologia de pedágio chegou ao Brasil. E para tornar sua viagem ainda mais rápida e fluida, a gente chegou junto.</h2>
          </div>
          <div className="w-full md:w-1/2 md:max-w-96 flex justify-start items-center flex-col bg-gray-200 rounded-xl p-6 min-h-96 md:max-h-calc(480px)">
            <h3 className="w-full text-black text-xl"><span className="font-bold">Consulte</span> e <span className="font-bold">gerencie</span> seus pagamentos, tudo em um só lugar.</h3>
            <p className="w-full text-black text-base mt-4">Consulta avulsa:</p>
            <InputMask 
              value={user?.plate as string ?? ''}
              name="plate" 
              placeholder="Digite sua placa" 
              className="uppercase w-full h-14 mt-2 rounded-xl p-3 text-black" 
              mask="___-.@.." 
              replacement={{ _: /\D/, ".": /\d/, "@": /[A-Za-z0-9]*/ }} 
              onChange={onChange} 
              type="text"
            />
            <div className="flex flex-row items-center justify-center mt-4">
              <input 
                type="checkbox" 
                name="terms"
                className="w-6 h-6 accent-green-600 mr-2"
                onChange={toggleTerms}
                checked={isAcceptedTerms}
              />
              <p className="w-full  text-sm text-black">Aceito a <Link to="/" className="underline italic text-principal">Política de Privacidade</Link> e os <Link to="/" className="underline italic text-principal">Termos e Condições de Uso.</Link></p>
            </div>
            <button 
              type="submit" 
              className={`w-full mt-6 h-14 w-full text-white border p-3 rounded-xl ${isDisabled ? "bg-gray-300 text-white" : "bg-black border-black hover:bg-transparent hover:text-black"}`} 
              onClick={isDisabled ? () => null : goToDebts}
              disabled={isDisabled}>
              Buscar débitos
            </button>
          </div>
        </article>

      </main>
      {isVisibleModal && renderModal()}
      {isLoading && <Loading />}
    </div>
  );
}
